module.exports = __webpack_public_path__ + "static/media/Logo__Linode.2986e1a8.svg";